(() => {
  const enhance = (root) => {
    root.querySelectorAll('.rf-collection-review .collection_description p, .rf-collection-review .collection_description div[data-paragraph="true"]').forEach((block) => {
      const hasContent = block.textContent.replace(/\u00a0/g, ' ').trim();
      const hasMedia = block.querySelector('img,picture,svg,video,audio,iframe,input,button,select,textarea,canvas,form');
      if (!hasContent && !hasMedia) block.dataset.rfctSpacer = 'true';
    });
    root.querySelectorAll('.rfcs-sort').forEach((form) => {
      if (form.dataset.enhanced === 'true') return;
      const select = form.querySelector('select[name="sort_by"]');
      if (!select) return;
      const navigate = () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.assign(url.toString());
      };
      select.addEventListener('change', navigate);
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        navigate();
      });
      form.dataset.enhanced = 'true';
    });
  };
  enhance(document);
  document.addEventListener('shopify:section:load', (event) => enhance(event.target));
})();
